import React from "react";
import { InputAndCharsCounter } from "@components/molecules/input-and-chars-counter/input-and-chars-counter";
import { TextareaAndCharsCounter } from "@components/molecules/textarea-and-chars-counter/textarea-and-chars-counter";
import { Button } from "@components/atoms/buttons/button/button";
import styles from "./save-content.module.scss";
import closeIcon from "@src/assets/svg/close-icon.svg";
import { BlueprintTable } from "@src/components/organisms/blueprint-table/blueprint-table";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { renderBlueprintPopover } from "../../helpers/render-blueprint-popover";
import { handleCloseDescriptionPopover } from "../../helpers/handle-close-description-popover";
import { GlassyModalHeader } from "@src/components/molecules/glassy-modal-header/glassy-modal-header";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { useSaveContentHook } from "./use-save-content-hook";

const cssClassName = "save-content";

export const SaveBlueprintModalContent = () => {
  const {
    popupRef,
    matchingBlueprintsArray,
    popoverPosition,
    activePopover,
    selectedBlueprint,
    inputValue,
    textareaValue,
    texts,
    setPopoverPosition,
    setActivePopover,
    closeModal,
    handleSaveBlueprintButtonClick,
    checkIfSaveButtonShouldBeDisabled,
    handleSelectBlueprint,
    handleInputChange,
    handleTextareaChange,
    setButtonVariantToInactiveIfDisabled,
    handleClickOnModal,
  } = useSaveContentHook();

  return (
    <div
      onClick={handleClickOnModal}
      onKeyDown={handleClickOnModal}
      role="button"
      tabIndex={0}
      ref={popupRef}
      className={styles[cssClassName]}
    >
      <GlassyModalHeader
        title={texts.subTitle}
        rightIcon={closeIcon}
        rightIconFunction={closeModal}
      />
      <HorizontalSeparator verticalMargin={16} />
      {matchingBlueprintsArray.length > 0 && (
        <div className={styles[`${cssClassName}__table-wrapper`]}>
          <BlueprintTable
            ref={popupRef}
            activeBlueprint={selectedBlueprint}
            blueprintArray={matchingBlueprintsArray}
            activeBlueprintCallback={handleSelectBlueprint}
            popoverPositionCallback={setPopoverPosition}
            activePopoverCallback={setActivePopover}
          />
        </div>
      )}
      <InputAndCharsCounter
        initialValue={inputValue}
        callback={handleInputChange}
      />
      <TextareaAndCharsCounter
        initialValue={textareaValue}
        callback={handleTextareaChange}
      />
      <HorizontalSeparator verticalMargin={16} />
      <FlexRowContainer>
        <Button
          fun={handleSaveBlueprintButtonClick}
          text={texts.saveButton}
          disabled={checkIfSaveButtonShouldBeDisabled()}
          variant={setButtonVariantToInactiveIfDisabled()}
        />
        <Button
          variant={["secondary"]}
          fun={closeModal}
          text={texts.cancelButton}
        />
      </FlexRowContainer>
      {renderBlueprintPopover(activePopover, popoverPosition, (e) =>
        handleCloseDescriptionPopover(e, setActivePopover),
      )}
    </div>
  );
};
